import axios from 'axios';

/** Shared axios/API error message extraction for Process Service create/update saves. */
export const getPsSaveErrorMessage = (error: unknown, fallback: string): string => {
  if (axios.isAxiosError(error)) {
    const data = error.response?.data as
      | { error?: { message?: string; details?: string | { message?: string }[] } }
      | undefined;
    const details = data?.error?.details;
    if (Array.isArray(details) && details[0]?.message) return details[0].message;
    if (typeof details === 'string' && details.trim()) return details;
    if (typeof data?.error?.message === 'string' && data.error.message.trim()) return data.error.message;
  }
  if (error instanceof Error && error.message) return error.message;
  return fallback;
};
